<template>
  <div>
    <CRow class="mb-3 search-panel">
      <CCol xs="12" sm="1" class="form-group" style="min-width: 105px; max-width: 120px;">
        <label>Thao tác</label>
        <div class="dropdown btn-group" style="height: 36px;">
          <button class="btn">
            <div class="group-checkbox">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  v-model="actionData.model.selectedAll"
                  @change="changeSelectAll"
                  id="selectedAll"
                />
                <label class="custom-control-label" for="selectedAll"></label>
              </div>
            </div>
          </button>
          <button
            type="button"
            class="dropdown-toggle dropdown-toggle-split btn"
            data-toggle="dropdown"
            aria-expanded="false"
            aria-haspopup="true"
          ></button>
          <div class="dropdown-menu">
            <button
              :disabled="actionData.model.listSystemSelectedId.length === 0"
              class="dropdown-item"
              @click="setupSelectOneAction('delete_list')"
              color="danger"
            >
              <CIcon name="cil-trash" style="danger" class="mr-2"/>
              Xóa tất cả
            </button>
          </div>
        </div>
      </CCol>
      <CCol sm="2" xs="12">
        <BaseInput
          :options="codeInput.options"
          :data="codeInput.data"
          :listener="codeInput.listener"
        />
      </CCol>
      <CCol sm="2" xs="12">
        <BaseInput
          :options="nameInput.options"
          :data="nameInput.data"
          :listener="nameInput.listener"
        />
      </CCol>
<!--      <CCol sm="2" xs="12">-->
<!--        <BaseInput-->
<!--          :options="urlInput.options"-->
<!--          :data="urlInput.data"-->
<!--          :listener="urlInput.listener"-->
<!--        />-->
<!--      </CCol>-->
      <CCol sm="2" xs="12">
        <BaseSelect :options="statusSelect.options" :data="statusSelect.data"
                              ref="statusSelect"></BaseSelect>
      </CCol>
      <CCol>
        <div class="form-group">
          <label style="color: white"></label>
          <div style="margin-top: 10px">
            <CButton
              style="float: right;margin-left: 5px;"
              color="primary"
              v-c-tooltip.hover="'Tải lại'"
              class="btn-action-primary"
              @click="loadDataMainTable(true)">
              <i class="fa fa-refresh"></i>&nbsp;&nbsp; Tải lại
            </CButton>
            <CButton
              style="float: right;"
              color="primary"
              v-c-tooltip.hover="'Thêm mới'"
              class="btn-action-primary"
              @click="$router.push('/system-management/new')"
            >
              <i class="fa fa-plus"></i>&nbsp;&nbsp; Thêm mới
            </CButton>
          </div>
        </div>
      </CCol>
    </CRow>
    <CCard class="content-fade-in mt-3p5">
      <CCardBody>
        <BaseTable
          :options="mainTable.options"
          :slots="mainTable.slots"
          :dataSource="mainTable.dataSource"
          ref="mainTable"
        >
          <template #checkbox="{item}">
            <td class="group-checkbox">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  v-model="actionData.model.listSystemSelectedId"
                  :value="item.id"
                  :id="item.id"
                  v-c-tooltip.hover="'Selected'"
                />
                <label class="custom-control-label" :for="item.id"></label>
              </div>
            </td>
          </template>

          <template #createDate="{item}">
            <td v-if="item.createDate != null">
              {{ $helper.formatDateDDMMYYYYHHMM(item.createDate) }}
            </td>
            <td v-if="item.createDate == null">

            </td>
          </template>
          <template #status="{item}">
            <td>
              <span v-if="item.status" class="dot-custom dot-success">Hoạt động</span>
              <span v-else class="dot-custom dot-danger">Không hoạt động</span>
            </td>
          </template>

          <template #action="{item}">
            <td class="action-btn-group">
              <div class="action-btn-wrapper">
                <CButton
                  color="info"
                  variant="outline"
                  v-c-tooltip.hover="'Cập nhật'"
                  square
                  size="sm"
                  @click="$router.push(`/system-management/managed-system/${item.id}`)"
                >
                  <CIcon name="cil-pencil"/>
                </CButton>
                <CButton
                  color="danger"
                  variant="outline"
                  class="ml-1"
                  square
                  size="sm"
                  v-c-tooltip.hover="'Xóa'"
                  @click="
                    setupSelectOneAction('delete_one', item.id, item.name)
                  "
                >
                  <CIcon name="cil-trash"/>
                </CButton>
              </div>
            </td>
          </template>
        </BaseTable>
      </CCardBody>
    </CCard>
    <ModalConfirm :actionTypeMapping="actionData.actionTypeMapping"
                  ref="actionModal"></ModalConfirm>
  </div>
</template>

<script>
import BaseTable from "../base/BaseDataTable";
import ModalConfirm from "../base/BaseModalConfirm";
import BaseInput from "../base/BaseInput";
import BaseSelect from "../base/BaseSelect2"

export default {
  name: "systemList",
  components: {
    BaseTable,
    ModalConfirm,
    BaseInput,
    BaseSelect
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Error"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data() {
    let that = this;
    let actionTypeMapping = new Map();

    actionTypeMapping.set("delete_one", {
      url: "/system/deleteSystem",
      titlePopup: function () {
        return that.$helper.setupTitleAction(
          "xóa",
          "hệ thống",
          that.actionData.model.systemSelectedName
        );
      },
      isJsonContentType: false,
      // type: 'PUT',
      dataSubmit: function () {
        return {id: that.actionData.model.systemSelectedId};
      },
      successCallback: function () {
        that.actionData.model.listSystemSelectedId = [];
        that.showSuccessMsg({message: "Xóa hệ thống " + that.actionData.model.systemSelectedName + " thành công"});
        that.loadDataMainTable();
      }
    });

    actionTypeMapping.set("delete_list", {
      url: "/system/deleteSystems",
      titlePopup: function () {
        return that.$helper.setupTitleAction("Xóa", "các hệ thống", "đã chọn");
      },
      isJsonContentType: false,
      // type: 'PUT',
      dataSubmit: function () {
        return {
          lsId: that.actionData.model.listSystemSelectedId
        };
      },
      successCallback: function () {
        that.actionData.model.listSystemSelectedId = [];
        that.showSuccessMsg({message: "Xóa danh sách hệ thống thành công"});
        that.loadDataMainTable();
      },
    });

    return {
      actionData: {
        actionTypeMapping: actionTypeMapping,
        model: {
          selectedAll: false,
          systemSelectedId: null,
          systemSelectedName: null,
          listSystemSelectedId: []
        }
      },
      codeInput: {
        options: {
          placeholder: "Mã hệ thống",
          label: 'Mã hệ thống'
        },
        data: {
          name: "code",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      nameInput: {
        options: {
          placeholder: "Tên hệ thống",
          label: 'Tên hệ thống'
        },
        data: {
          name: "name",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      // urlInput: {
      //   options: {
      //     placeholder: "URL",
      //     label: 'URL'
      //   },
      //   data: {
      //     name: "url",
      //     model: "",
      //     updateTrigger: function () {
      //       return that.$refs.mainTable;
      //     }
      //   }
      // },
      statusSelect: {
        options: {
          filter: false,
          label: 'Trạng thái',
        },
        data: {
          name: "status",
          items: [
            {key: "null", value: "Tất cả trạng thái"},
            {key: "1", value: "Hoạt động"},
            {key: "0", value: "Không hoạt động"},
          ],
          model: "null",
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      mainTable: {
        options: {
          fields: [
            {key: "checkbox", label: "#"},
            {key: "createDate", label: "Ngày tạo"},
            {key: "code", label: "Mã hệ hống"},
            {key: "name", label: "Tên hệ hống"},
            {key: "url", label: "URL"},
            {key: "description", label: "Mô tả"},
            {key: "status", label: "Trạng thái"},
            {key: "action", label: "Thao tác"}
          ],
          slots: ["checkbox", "status", "createDate", "action"],
        },
        dataSource: {
          url: "/system/pageSystems",
          dataSubmit: function () {
            return that.$helper.setupDataSubmit(that.$data);
          },
          response: function (dataResponse) {
            return dataResponse.data;
          }
        }
      }
    };
  },
  methods: {
    loadDataMainTable: function (isUpdateFilter) {
      this.$refs.mainTable.loadData(true, isUpdateFilter);
    },
    changeSelectAll: function (event) {
      var listSystemSelectedId = this.actionData.model.listSystemSelectedId;
      if (this.actionData.model.selectedAll) {
        this.actionData.model.listSystemSelectedId = [];

        this.$refs.mainTable.items.forEach(each => {
          this.actionData.model.listSystemSelectedId.push(each.id);
        });
      } else {
        this.actionData.model.listSystemSelectedId = [];
      }
    },
    setupSelectOneAction: function (actionTypeKey, systemSelectedId, systemSelectedName) {
      var actionData = this.actionData.model;
      actionData.systemSelectedId = systemSelectedId || null;
      actionData.systemSelectedName = systemSelectedName || null;
      this.$refs.actionModal.setCurrAction(actionTypeKey);
    },
    setupSelectMoreAction: function (actionTypeKey) {
      this.$refs.actionModal.setCurrAction(actionTypeKey);
    }
  },
  created: function () {
  },
  mounted() {
  },
  watch: {
    "actionData.model.listSystemSelectedId": function (newValue) {
      var that = this;
      if (newValue.length === that.$refs.mainTable.items.length) {
        that.actionData.model.selectedAll = true;
      } else {
        that.actionData.model.selectedAll = false;
      }
    }
  },
  computed: {}
};
</script>
<style scoped>
.td-roles {
  max-width: 250px;
}
</style>
